import { api } from './APIMiddlewares'
import { setupAxios } from '../app/modules/auth'

// ==============================
// GET LOCATIONS
// ==============================
export const getLocations = (activeOnly = false) => {
  const { token } = setupAxios()

  return api.get(
    `/location-master?active=${activeOnly}`,
    token,   // ✅ send token
    null,
    false
  )
}


// ==============================
// CREATE LOCATION (FORM-DATA)
// ==============================
export const createLocation = (data: any) => {
  const { token } = setupAxios()

  const formData = new FormData()
  formData.append('code', data.code)
  formData.append('name', data.name)
  formData.append('address', data.address || '')
  formData.append('city', data.city || '')
  formData.append('state', data.state || '')
  formData.append('country', data.country || '')
  formData.append('pincode', data.pincode || '')

  return api.post(
    '/location-master',
    token,
    null,
    { body: formData },
    true,
    true
  )
}



// ==============================
// UPDATE LOCATION
// ==============================
export const updateLocation = (id: string, data: any) => {
  const { token } = setupAxios()

  const formData = new FormData()
  formData.append('code', data.code)
  formData.append('name', data.name)
  formData.append('address', data.address || '')
  formData.append('city', data.city || '')
  formData.append('state', data.state || '')
  formData.append('country', data.country || '')
  formData.append('pincode', data.pincode || '')

  return api.put(
    `/location-master/${id}`,
    token,
    null,
    { body: formData },
    true,
    true
  )
}


// ==============================
// TOGGLE STATUS
// ==============================
export const toggleLocationActive = (id: string) => {
  const { token } = setupAxios()

  const formData = new FormData()

  return api.patch(
    `/location-master/${id}/toggle-status`,
    token,               // ✅ send token
    null,
    { body: formData },  // ✅ wrap in body
    true,
    true                // ✅ IMPORTANT
  )
}

